import { Layout } from '../components/Layout.js';
import { WelcomePanel } from '../components/WelcomePanel.js';

/**
 * /help page — full-width render of the welkomstpaneel content.
 * Always shows the latest version (no dismissal cursor checks here);
 * users can revisit any time via the sidebar Help link.
 */
export function HelpPage(): JSX.Element {
  return (
    <Layout>
      <WelcomePanel variant="full-page" />
    </Layout>
  );
}
